<template>
  <div>
      <PmNoRealTaskLeftTreeForResource @resourceTreeClickEventPush="resourceTreeClickEventPush" ref="PmNoRealTaskResourceTreePage"></PmNoRealTaskLeftTreeForResource>
  </div>
</template>

<script>
import PmNoRealTaskLeftTreeForResource from './PmNoRealTaskLeftTreeForResource';

export default {
  name: 'PmNoRealTaskLeftTree',
  components: {
    PmNoRealTaskLeftTreeForResource,
  },
  data() {
    return {

    }
  },
  methods: {
    // 网元树点击节点信息事件发布
    resourceTreeClickEventPush(params) {
      this.$emit('resourceTreeClickEventPush', params);
    },
  }
};
</script>

<style>

</style>
